import {
  Component,
  input,
  signal,
  OnInit,
  inject,
  computed,
  afterNextRender,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NodeProratpa, Rating } from '@app/models/entity.model';
import { TeaserComponent } from '@app/components/teaser/teaser.component';
import { StarRatingComponent } from '@app/components/star-rating/star-rating.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { ViewComponent } from '@app/components/view/view.component';
import { DrupalService } from '@app/services/drupal.service';
import { DataService } from '@app/services/data.service';
import { MobiUiExpanderComponents } from '@mobi/rwc-ui-components-ng-jslib';
import { WebformModule } from '@app/components/webform/webform.module';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { CalcUrlPipe } from '@app/pipes/calc-url.pipe';
import { TextComponent } from '@app/components/text/text.component';

@Component({
  selector: 'mobi-node-proratpa',
  imports: [
    TeaserComponent,
    StarRatingComponent,
    ContentSectionComponent,
    ViewComponent,
    MobiUiExpanderComponents,
    WebformModule,
    MobiUiIconComponent,
    CalcUrlPipe,
    TextComponent,
  ],
  templateUrl: './node-proratpa.component.html',
  styleUrl: './node-proratpa.component.scss',
})
export class NodeProratpaComponent implements OnInit {
  readonly entity = input.required<NodeProratpa>();
  filter: { [key: string]: any } = {};
  rating = signal<Rating>({ average_rating: 0, count: 0 });
  #drupal = inject(DrupalService);
  #data = inject(DataService);
  readonly #http = inject(HttpClient);

  #afterRender = afterNextRender({
    write: async () => {
      this.isLoading.set(true);
      const rating: any = await this.#data.getProductRating(this.entity().product.id);
      this.rating.set(rating);
      this.isLoading.set(false);
    },
  });
  isLoading = signal(false);

  selectedProduct = computed(() => this.entity().sproduct ?? this.entity().product);

  locale = computed(() => this.#drupal.language() + '-CH');

  formatDate(dateString: string) {
    const dateOptions = {
      month: 'long',
      year: 'numeric',
    };
    const dateObj = new Date(dateString);
    // @ts-ignore
    return dateObj.toLocaleDateString(this.#drupal.language() + '-CH', {
      month: 'long',
      year: 'numeric',
    });
  }

  expandedRows = new Set<number>();

  toggleRow(index: number, event: MouseEvent | KeyboardEvent) {
    // Handle only Enter and Space for keyboard events
    if (event instanceof KeyboardEvent && !['Enter', ' '].includes(event.key)) {
      return;
    }

    if (
      event.target instanceof HTMLElement &&
      event.target.closest('mobi-ui-icon-major')
    ) {
      event.stopPropagation();
      return;
    }

    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
    }
  }

  isExpanded(index: number): boolean {
    return this.expandedRows.has(index);
  }

  getAriaLabel(row: any): string {
    return `${row.field_prorat_ga.title} by ${row.field_prorat_aname}. Rating: ${row.field_prorat_rating} out of 5`;
  }

  ngOnInit() {
    if (this.filter['#attributes']?.min && this.filter['#attributes']?.max) {
      const min = parseInt(this.filter['#attributes'].min);
      const max = parseInt(this.filter['#attributes'].max);
      this.filter['#optionsArray'] = this.generateRatingOptions(min, max);
    }
  }

  generateRatingOptions(min: number, max: number): { key: string; value: string }[] {
    const options: { key: string; value: string }[] = [];
    for (let i = min; i <= max; i++) {
      options.push({ key: i.toString(), value: i.toString() });
    }
    return options;
  }
}
